import React, { useEffect } from 'react';

const shouldRender =
  process.env.GATSBY_REGION_REGION_DIFFERENTIATOR.includes('US B2C');

export const Affirm: React.FC<{ price: number }> = ({ price }) => {
  useEffect(() => {
    if (shouldRender && window.affirm) {
      window.affirm.ui.ready(() => {
        window.affirm.ui.refresh();
      });
    }
  }, []);

  if (!shouldRender) {
    return null;
  }

  return (
    <p
      className="affirm-as-low-as -mt-4 mb-4 text-center text-sm text-black-600 md:text-left"
      data-page-type="product"
      // Affirm wants the price in cents
      data-amount={`${price * 100}`}
    >
      &nbsp;
    </p>
  );
};
